module.exports = __webpack_public_path__ + "static/fonts/proximasoftbold-webfont.566af57.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximasoftbold-webfont.eot
// module id = 1018
// module chunks = 11